import icons from 'constants/icons';

/** Sidebar `icon` prop keys for each tour section — keep in sync with SidebarContent. */
const TOUR_SECTION_ICON_KEYS = {
  home: 'home',
  'agency-management': 'agencyDashboard',
  'onboarding-dashboard': 'onboardingDashboard',
  'agency-settings': 'agencySettings',
  'appointment-center': 'agencyAppointments',
  'carrier-appointments': 'myAppointments',
  submissions: 'policy',
  'commissions-overview': 'bonus',
  resources: 'resources',
  'public-resources': 'web',
  'personal-resources': 'agentInfo',
  'content-library': 'library',
  leads: 'lead'
};

export function getTourSectionIconComponent(sectionId) {
  const key = TOUR_SECTION_ICON_KEYS[sectionId] || 'home';
  return icons[key] || icons.home;
}
